import { render, staticRenderFns } from "./short-answer-question-component.vue?vue&type=template&id=37d7c504&scoped=true&"
import script from "./short-answer-question-component.vue?vue&type=script&lang=ts&"
export * from "./short-answer-question-component.vue?vue&type=script&lang=ts&"
import style0 from "./short-answer-question-component.vue?vue&type=style&index=0&id=37d7c504&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d7c504",
  null
  
)

export default component.exports